export class CustomerRegisterParams {
    page? = 1;
    limit? = 20;
    search?: string;
}
